import _ from "lodash";
import React, { useState, useEffect } from "react";

import { Route, Switch, Redirect, useRouteMatch } from "react-router-dom";
import { Error400 } from "views/pages";
import IntlMessages from "util/intlMessages";
import ContentTable from "./Table";
import { PageTitle } from "components/standart";
import AddSelection from "./Add";
import ContentInfo from "./Info";
import SpecialsSelectionPrompt from "./Prompt";
import { path } from "./init";

const SpecialsSelections = (props) => {
  const { url, path } = useRouteMatch();
  const { breadCrumbs } = props;

  breadCrumbs.push({
    title: <IntlMessages id="Specials.Selections" />,
    url,
    actions: [<SpecialsSelectionPrompt />, <AddSelection />],
  });

  return (
    <Switch>
      <Route exact path={`${path}`}>
        <PageTitle {...breadCrumbs} />

        <ContentTable />
      </Route>

      <Route path={`${path}/selection_:selectionId`}>
        <ContentInfo {...{ breadCrumbs }} />
      </Route>

      <Route component={Error400} />
    </Switch>
  );
};

SpecialsSelections.path = path;

export default SpecialsSelections;
